import React from 'react'
import { TabProps } from '@material-ui/core'
import Tab from '@material-ui/core/Tab'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

const YumTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      //minHeight: '32px',
      minWidth: 'auto',
      textTransform: 'none',
      borderRadius: '8px',
      fontWeight: 600,
      fontSize: '0.8125rem',
      //lineHeight: '16px',
      lineHeight: '1rem',
      whiteSpace: 'nowrap',

      //padding: '4px 12px',
      padding: '0.375rem 0.75rem',
      //minHeight: '28px',
      minHeight: '1.75rem',
    },
    textColorPrimary: {
      color: theme.palette.text.primary,
    },
    selected: {
      //color: 'white !important',
      //backgroundColor: 'white',
    },
    wrapper: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
    },
  }),
)(({ classes, ...props }: TabProps) => {
  return <Tab classes={classes} {...props} />
})

export default YumTab
